<template>
  <div>
    <el-dialog :title="title" :visible="visible" width="80%" @close="onClose">
      <div style="display: flex;justify-content: flex-start;border-top:1px solid #e5e5e5;padding-top: 15px;">
        <div style="width:25%">
          <div class="custom-tree-node" style="padding-bottom: 5px;padding-left: 20px;">
            <span>全部图片</span>
            <label>...</label>
          </div>
          <el-tree
            :data="docCateList"
            node-key="id"
            :props="defaultProps"
            default-expand-all
            :expand-on-click-node="false">
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span>{{ node.name }}</span>
        <span>
          <el-button
            type="text"
            size="mini"
            @click="() => append(data)">
            ...
          </el-button>
        </span>
      </span>
          </el-tree>
        </div>

        <div>
          <el-form label-width="110px" :inline="true" size="mini">
            <el-form-item >
              <el-input v-model="keywords" clearable placeholder="图片名称"></el-input>
            </el-form-item>
            <el-form-item>
              <el-button @click="goSearch">查询</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="uploadDoc">使用选中图片</el-button>
            </el-form-item>
            <el-form-item>
              <el-button type="primary"  @click="uploadDoc">上传图片</el-button>
            </el-form-item>
          </el-form>
          <el-table
            ref="multipleTable"
            :data="mList"
            height="300"
            stripe
            border
            size="mini"
            :header-cell-style="{background:'#e5e5e5',color:'#333333'}"
          >
            <el-table-column label="" width="50" align="center">
              <template slot-scope="scope">
                <el-radio v-model="curShop"  :label="scope.row" @input="clickChange(scope.row,scope.$index)">{{ "" }}</el-radio>
              </template>
            </el-table-column>
            <el-table-column
              label="缩略图"
              width="100"
            >
              <template slot-scope="scope">
                <el-image
                  style="height: 60px;width: 80px;"
                  :src="scope.row.url"
                  class="custom-image"
                ></el-image>
              </template>
            </el-table-column>
            <el-table-column
              label="文件名称"
              width="300"
              prop="name"
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              label="文件后缀"
              width="80"
              prop="ext"
              :show-overflow-tooltip='true'
            >
            </el-table-column>
            <el-table-column
              label="文件大小"
              width="100"
              :show-overflow-tooltip='true'
            >
              <template slot-scope="scope">
                <span>{{ scope.row.size }}</span>
              </template>
            </el-table-column>
            <el-table-column
              label="创建时间"
              width="200"
              :show-overflow-tooltip='true'
            >
              <template slot-scope="scope">
                <span>{{ timeFormat(scope.row.create_time) }}</span>
              </template>
            </el-table-column>
          </el-table>
          <div class="block" style="margin-top:10px">
            <el-pagination
              background
              @size-change="handleSizeChange"
              @current-change="handleCurrentChange"
              :current-page="pageNum"
              :page-sizes="[10, 20, 30, 100]"
              :page-size="pageSize"
              layout="total, sizes, prev, pager, next, jumper"
              :total="total">
            </el-pagination>
          </div>
          <el-row>
            <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
              <el-button size="mini" @click="close">取消</el-button>
              <el-button  size="mini" type="primary" @click="ok">确定</el-button>
            </el-col>
          </el-row>

        </div>

      </div>
      <el-dialog custom-class="inner-dialog" append-to-body title="文件上传" :visible.sync="isShow" width="80%">
                <el-row>
                  <el-col>
                      <el-upload
                        class="upload-demo"
                        drag
                        action="#"
                        :before-upload="handleBeforeUpload"
                        :on-success="uploadSuccess"
                        :auto-upload="false"
                        :on-change="uploadFile"
                        :file-list="fileList"
                        list-type="picture"
                        multiple
                      >
                        <i class="el-icon-upload"></i>
                        <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
                        <div class="el-upload__tip" slot="tip">只能上传jpg/png文件，且不超过500kb</div>
                      </el-upload>
                  </el-col>
                </el-row>
        <el-row>
          <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
            <el-button size="mini" @click="closeUpload">取消</el-button>
            <el-button  size="mini" type="primary" @click="goUpload">确定</el-button>
          </el-col>
        </el-row>
      </el-dialog>
    </el-dialog>

  </div>
</template>
<script>
  import CryptoJS from "crypto-js";
  import moment from "moment";
  import axios from "axios";
  export default {
    name:'eDocList',
    props: {
      visible: {
        type: Boolean,
        default: false,
      },
      formData: {
        type: Object,
        default: null,
      },
      title: {
        type: String,
        default: "",
      },
      closeForm: Function,
    }
    ,
    data(){
      return {
        defaultProps: {
          children: 'children',
          label: 'name',
        },
        docCateList:[

        //   {
        //   id: 1,
        //   label: '一级 1',
        //   children: [{
        //     id: 4,
        //     label: '二级 1-1',
        //     children: [{
        //       id: 9,
        //       label: '三级 1-1-1'
        //     }, {
        //       id: 10,
        //       label: '三级 1-1-2'
        //     }]
        //   }]
        // }, {
        //   id: 2,
        //   label: '一级 2',
        //   children: [{
        //     id: 5,
        //     label: '二级 2-1'
        //   }, {
        //     id: 6,
        //     label: '二级 2-2'
        //   }]
        // }
        ],

        isShow:false,
        index:'',
        curShop:'',
        id:'',
        name:'',
        url:'',
        keywords:'',
        fileList:[],
        mList:[],
        pageNum:1,
        pageSize:10,
        total:0,
        item:{}
      }
    },
    mounted() {
      console.log('--------','')
      this.DataList();
      this.getUploadCategoryTree();
    },
    methods:{
      goSearch(){
        this.pageNum = 1;
        this.DataList()
      },
      append(){

      },
      closeUpload(){
        this.isShow=false;
      },
      getUploadCategoryTree(){
        let _this=this;
        let params={
          access_token:sessionStorage.getItem('token'),
          company_id:sessionStorage.getItem('company_id'),
        };
        this.$axios.findUploadCategoryTree(params).then((res)=>{
          if(res.code==200){
           _this.docCateList=res.data;
          }
          console.log(res);
        });
      },
      goUpload(){
            let _this=this;
            let params={
              access_token:sessionStorage.getItem('token'),
              company_id:sessionStorage.getItem('company_id'),
              name:_this.formData.name,
              foreign_id:_this.formData.foreign_id,
              contract_id: _this.formData.contract_id,
              source: _this.formData.source,
              upload_id:_this.formData.upload_id
            };
            console.log('uploadForeignSave params------',params)
            this.$axios.uploadForeignSave(params).then((res)=>{
              if(res.code==200){
                this.$message({
                  message:'添加成功！',
                  type:'success',
                  offset:225,
                  duration:4000,
                  onClose:()=>{
                   // this.$router.push('/preApprovalList')
                  }
                });
                _this.isShow=false;
                _this.pageNum=1;
                _this.DataList();
              }
              console.log(res);
            });
      },
      uploadDoc(){
        this.isShow=true;
      },
      // 设置每页条数
      handleSizeChange(newSize) {
        this.pageSize = newSize
        this.DataList()
      },
      // 分页跳转
      handleCurrentChange(newPage) {
        this.pageNum = newPage
        this.DataList()
      },
      onClose(){
        this.$emit('update:visible',false)
        this.closeForm();
      },
      close(){
        this.$emit('update:visible',false)
        this.closeForm();
      },
      ok(){
        this.$emit('eventChoose',this.id,this.name,this.url);
        this.closeForm();
      },
      DataList(){

        const param = {
          company_id:sessionStorage.getItem('company_id'),
          access_token:sessionStorage.getItem('token'),
          source:this.formData.source,
          foreign_id:this.formData.foreign_id,
          contract_id:this.formData.contract_id,
          pageNum: this.pageNum,
          pageSize: this.pageSize,
        }
        if(this.keywords){
          param.keywords=this.keywords;
        }
        console.log('eDocList--------',param)
        this.$axios.findUploadListP(param).then(res=>{
          if(res.code == 200){
            this.mList = res.data.data
            this.total = res.data.total
          }
        }).catch(error=>{
          console.log(error);
        })
      },
      clickChange(row,index){
        this.index=index;
        this.id=row.id;
        this.name=row.name;
        this.url=row.url;
        // this.formData.name=row.name;
        // this.formData.id=row.id;
        // this.formData.url=row.url;
        this.item=this.mList[index];
        console.log('row----',row);
      },
      handleBeforeUpload(){

      },
      uploadSuccess(){

      },
      async uploadFile (item) {
        let _this=this;
       // let formData = new FormData()
        let file = item.raw;
        this.logoFile=item.raw;

        let file_md5, file_sha1;
        await this.calculateMD5(file).then(md5 => {
          file_md5 = md5;
          console.log('MD5:', md5)
        });
        await this.calculateSHA1(file).then(sha1 => {
          file_sha1 = sha1;
          console.log('SHA1:', sha1);
        });

        // 获取文件名
        const fileName = file.name;
        // 获取文件大小
        const fileSize = file.size;
        // 获取文件后缀
        const fileExtension = fileName.substring(fileName.lastIndexOf('.') + 1);
        console.log('文件名称：', fileName);
        console.log('文件后缀：', fileExtension);
        console.log('文件大小：', fileSize);
        let param_1 = {
          access_token: sessionStorage.getItem('token'),
          company_id: sessionStorage.getItem('company_id'),
          md5: file_md5,
          sha1: file_sha1,
          size: fileSize
        };
        this.$axios.uploadOne(param_1).then(res => {
          if (res.code == 200&&res.data.length>0) {

            //文件已经存在
            _this.formData.file_url = res.data.url;
            _this.formData.upload_id=res.data.id;

            var img = {
              name: res.data.name,
              url: res.data.url
            }
            _this.fileList.push(img);

          } else {

           //保存到阿里云
            let param = {
              access_token: sessionStorage.getItem('token'),
              company_id: sessionStorage.getItem('company_id'),
            };
            // console.log(file);
            this.$axios.getAliJsonCmp(param).then(res => {
              console.log('ali_json------', res)
              let data = res['data'];
              console.log(data);
              let suffix = _this.get_suffix(file.name);
              let autoname = _this.Ymdhis();
              let key = data['dir'];
              let host = data['host'];

              let path = data['path'] != null && data['path'] != undefined ? data['path'] : '';
              let request = new FormData();
              request.append('name', file.name);
              request.append("key", key + path + autoname + suffix);//文件名字，可设置路径
              request.append("policy", data['policy']);//policy规定了请求的表单域的合法性
              request.append("OSSAccessKeyId", data['accessid']);//Bucket 拥有者的Access Key Id。
              request.append("success_action_status", '200');// 让服务端返回200,不然，默认会返回204
              request.append("callback", data['callback']);//回调，非必选，可以在policy中自定义
              request.append("Signature", data['signature']);//根据Access Key Secret和policy计算的签名信息，OSS验证该签名信息从而验证该Post请求的合法性
              request.append('file', file);//需要上传的文件 file
              console.log('request=------', request)
              _this.uploadAliOss(host,request).then(url=>{
                var fileurl = url; //上传完成后的文件oss地址
                var fullurl = host + '/' + fileurl;
                  _this.formData.file_url=fullurl;
                  _this.formData.name=file.name;
                  var img={
                    name:_this.formData.name,
                    url:_this.formData.file_url
                  }
                  _this.fileList.push(img);
                //更新上传资料
                let upload_params = {
                  access_token: sessionStorage.getItem('token'),
                  company_id: sessionStorage.getItem('company_id'),
                  name: fileName,
                  size: fileSize,
                  ext: fileExtension,
                  md5: file_md5,
                  sha1: file_sha1,
                  path: fileurl,
                  url: fullurl,
                  status: 1,
                };
                console.log('upload---save params', upload_params)
                _this.$axios.uploadSave(upload_params).then(resu => {
                  _this.formData.upload_id=resu.data.id;
                  console.log('upload---save', resu)
                });
              });

            });

            //保存到本地
            // formData.append('file', file);
            // formData.append('csn','chy');
            // this.$axios.ossLocalUploadFile(formData).then(res => {
            //   //请求成功，触发then中的函数
            //   console.log('lu------888---upload -res--------',res)
            //   var fullurl=res.data;
            //   var fileurl=res.path;
            //   _this.formData.file_url=fullurl;
            //   _this.formData.name=file.name;
            //   var img={
            //     name:_this.formData.name,
            //     url:_this.formData.file_url
            //   }
            //   _this.fileList.push(img);
            //  //更新上传资料
            //   let upload_params = {
            //     access_token: sessionStorage.getItem('token'),
            //     company_id: sessionStorage.getItem('company_id'),
            //     name: fileName,
            //     size: fileSize,
            //     ext: fileExtension,
            //     md5: file_md5,
            //     sha1: file_sha1,
            //     path: fileurl,
            //     url: fullurl,
            //     status: 1,
            //   };
            //   console.log('upload---save params', upload_params)
            //   _this.$axios.uploadSave(upload_params).then(resu => {
            //     _this.formData.upload_id=resu.data.id;
            //     console.log('upload---save', resu)
            //   }).catch(error=>{
            //     console.log('upload---error', error)
            //   });
            //
            //
            // })
            //   .catch(error =>
            //     //请求失败，触发catch中的函数 可省略
            //     console.log(error)
            //   )

          }
        });




      },
      async readFileAsBinaryString(file) {
        return new Promise((resolve, reject) => {
          const reader = new FileReader();
          reader.onload = () => resolve(reader.result);
          reader.onerror = error => reject(error);
          reader.readAsBinaryString(file);
        });
      },
      async  calculateMD5(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.MD5(words).toString();
        });
      },
      async calculateSHA1(file) {
        return  this.readFileAsBinaryString(file).then(binaryString => {
          const words = CryptoJS.lib.WordArray.create(binaryString);
          return CryptoJS.SHA1(words).toString();
        });
      },
      async uploadAliOss(host,formData){
        return new Promise((resolve, reject) => {
          axios.post(host, formData,{headers: {'Content-Type': 'multipart/form-data'}}).then(res => {
            console.log('ali oss res 上传结果:',res)
            resolve(res.data.filename) // 假设服务器返回的图片 URL 是 response.data.url
          }).catch(error => {
            reject(error)
          })
        })
      },
      get_suffix(filename) {
        let pos = filename.lastIndexOf('.')
        let suffix = ''
        if (pos != -1) {
          suffix = filename.substring(pos)
        }
        return suffix;
      },
      Ymdhis(){
        var date = new Date();
        var year = date.getFullYear();
        var month = date.getMonth()+1;
        var day = date.getDate();
        var hour = date.getHours();
        var minute = date.getMinutes();
        var second = date.getSeconds();
        return ''+year+month+day+hour+minute+second+(Math.floor(Math.random() * (10000 - 1000 + 1)) + 1000);
      },
      timeFormat(add_time) {
        if (add_time == undefined) {
          return "";
        }
        return moment(add_time*1000).format("YYYY-MM-DD HH:mm:ss");
      },
      chooseItem(){

      }
    },
    // 监听
    watch: {
      visible(val) {
        if (val) {
          // if (this.formData.img) {
          //   console.log(this.formData, " this.formData");
          //   this.formData.img = [
          //     {
          //       name: this.formData.img,
          //       url: this.formData.img,
          //     },
          //   ];
          // }
          this.pageNum=1;
          this.DataList();
        }
      },
    },
  }
</script>
<style lang="less" scoped>
  //https://www.yzktw.com.cn/post/1262748.html
  .upload_group {
    width: 100%;
    display: flex;
    justify-content: flex-start;
    align-items: center;

    .upload_list {
      width: 120px;
      margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
      font-size: 10px;
      color: #409EFF;
    }

    /deep/.el-icon-upload:before {
      width: 40px !important;
      height: 40px !important;
    }

    .upload_list:last-child {
      margin-right: 0;
    }

    /deep/.el-upload-dragger {
      width: 100%;
      height: auto;
      padding: 20px 0;
      border: 1px solid #999;
    }

    /deep/.el-upload {
      width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
      margin: 10px 0;
    }
  }
  .table_name:hover{
    color: #409EFF;
    cursor: pointer;
  }

  .inner-dialog /deep/ .el-dialog {
    z-index: 9999; /* 确保这个值高于外层 el-dialog 的 z-index */
  }

  .custom-tree-node {
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 14px;
    padding-right: 8px;
  }
  .custom-image img{width: 80px;height: 80px;}
 /deep/ .el-dialog__body{padding-top:0 !important;}
</style>
